<script setup lang="ts">
import { readItems } from '@directus/sdk'

const { locale, t } = useI18n()
const { request } = useDirectusRest()

const { data: faqs } = await useAsyncData(
  'customer-faq',
  () =>
    request(
      readItems('faq', {
        deep: {
          translations: {
            _filter: {
              languages_code: {
                _eq: locale.value,
              },
            },
          },
        },
        fields: [
          'id',
          'translations.*',
          'translations.question',
          'translations.answer',
          'translations.languages_code',
        ],
      }),
    ),
  {
    watch: [locale],
  },
)

const sections = ref([])


const closeOthers = (self: number) => {
  sections.value = sections.value.map((item, index) => {
    if (index === self) {
      return item
    }
    return false;
  });
}

</script>

<template>
  <div class="relative mx-auto max-w-5xl" id="faq">
    <h2 class="marker-alt relative mb-8 ms-2 inline-block text-3xl font-bold">
      {{ t('frequently_asked_questions') }}
    </h2>
    <div v-for="(faq,idx) of faqs">
      <FaqSection @clicked="closeOthers(idx)" v-model="sections[idx]" :key="faq.id" :text="faq.translations[0]?.answer" :title="faq.translations[0]?.question"
        class="border-b border-[#D9D9D9]" v-if="faq.translations[0]?.answer && faq.translations[0]?.question" />
    </div>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "frequently_asked_questions": "Frequently asked questions"
  },
  "nl": {
    "frequently_asked_questions": "Veelgestelde vragen"
  },
  "fr": {
    "frequently_asked_questions": "Questions fréquemment posées"
  }
}
</i18n>
